import { apiRequest } from "./apiClient";

export type WaterTransactionSummary = {
  id: number;
  accountId?: number | null;
  accountNo: string;
  atmId?: number | null;
  pumpName?: string | null;
  zoneName?: string | null;
  cardNumber?: string | null;
  unitWaterPrice?: number | null;
  waterDispenseLtr?: number | null;
  amount?: number | null;
  transactionDate?: string | null;
};

export type PaginationMeta = {
  page: number;
  pageSize: number;
  total: number;
  pages: number;
};

type WaterTransactionsResponse = {
  items: WaterTransactionSummary[];
  meta: {
    page: number;
    page_size: number;
    total: number;
    pages: number;
  };
};

export type FetchWaterTransactionsOptions = {
  page?: number;
  pageSize?: number;
  search?: string;
  fromDate?: string;
  toDate?: string;
  pumpId?: number;
  signal?: AbortSignal;
};

const buildQuery = (options?: FetchWaterTransactionsOptions) => {
  if (!options) {
    return "";
  }
  const params = new URLSearchParams();
  if (options.page && options.page > 0) {
    params.append("page", String(options.page));
  }
  if (options.pageSize && options.pageSize > 0) {
    params.append("pageSize", String(options.pageSize));
  }
  if (options.search?.trim()) {
    params.append("search", options.search.trim());
  }
  if (options.fromDate) {
    params.append("fromDate", options.fromDate);
  }
  if (options.toDate) {
    params.append("toDate", options.toDate);
  }
  if (options.pumpId) {
    params.append("pumpId", String(options.pumpId));
  }
  const query = params.toString();
  return query ? `?${query}` : "";
};

export async function fetchWaterTransactions(options?: FetchWaterTransactionsOptions) {
  const query = buildQuery(options);
  const response = await apiRequest<WaterTransactionsResponse>(`/api/water-transactions${query}`, {
    signal: options?.signal,
  });
  return {
    items: response.items,
    meta: {
      page: response.meta.page,
      pageSize: response.meta.page_size,
      total: response.meta.total,
      pages: response.meta.pages,
    } as PaginationMeta,
  };
}
